const Countries = {
  state: {
    countries: {}
  },
  getters: {
    getCountries: (state) => state.countries
  },
  actions: {},
  mutations: {
    setCountries(state, data) {
      if (data == null) {
        return []
      }
      state.countries = data
      return data
    }
  }
}

export default Countries



// WEBPACK FOOTER //
// ./src/store/modules/countries.js